import React, { Fragment, useContext } from 'react';
import loadable from '@loadable/component';
import { MODALS } from '../../../constants';
import FullScreenLoader from '../../FullScreenLoader';
import { Context } from '../../../context/AppContext';
import Modal from '../../Modal';
import './styles.css';

const SlideMenuLoadable = loadable(() => import('./SlideMenuLoadable'), {
  fallback: <FullScreenLoader />,
});

const SlideMenu = ({ hideReview }) => {
  const {
    media: { desktop },
    modal: { showModal },
  } = useContext(Context);

  return (
    <Fragment>
      <button
        className="Header__SlideMenu__button"
        onClick={() => showModal(MODALS.HEADER_SLIDE_MENU)}
      >
        <i className="icon-generalmenu" />
      </button>
      <Modal
        name={MODALS.HEADER_SLIDE_MENU}
        animation={desktop ? 'SlideMenuScale' : 'ModalScale'}
      >
        <SlideMenuLoadable hideReview={hideReview} />
      </Modal>
    </Fragment>
  );
};

export default SlideMenu;
